import {
  Container,
  Header,
  Title,
  Subtitle,
  IconButton,
  NavButtons,
  TestimonialGrid,
  Quote,
  Name,
  Person,
  Role,
  ImageWrapper,
  Highlight,
  TestimonialSection
} from './styles/Testimonials.styles';
import { ReactComponent as ArrowLeft } from 'static/icons/arrow-left.svg';
import { ReactComponent as ArrowRight } from 'static/icons/arrow-right.svg';
import TestimonialImage from 'static/images/textimonial-image.jpg';
import Testimonial3 from 'static/images/testimonials-3.png';
import Testimonial2 from 'static/images/testimonials-2.png';
import { useEffect, useRef, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const testimonials = [
  {
    quote: '“This has become a part of my daily dev arsenal.”',
    name: '',
    role: '',
    image: TestimonialImage
  },
  {
    quote: '“Saved me HOURS on an 800 page book. Lifesaving”',
    name: '',
    role: '',
    image: Testimonial2
  },
  {
    quote: '“It’s hard to imagine a time when we did all this manually.”',
    name: '',
    role: '',
    image: Testimonial3
  }
];

export default function IndustryTestimonialPage() {
  const [index, setIndex] = useState(0);
  const timeoutRef = useRef(null);

  const onPrev = () => {
    setIndex((i) => (i ? i - 1 : testimonials.length - 1));
    resetTimer();
  };
  const onNext = () => {
    setIndex((i) => (i + 1) % testimonials.length);
    resetTimer();
  };

  const resetTimer = () => {
    if (timeoutRef.current) clearInterval(timeoutRef.current);
    timeoutRef.current = setInterval(
      () => setIndex((prev) => (prev + 1) % testimonials.length),
      7000
    );
  };

  useEffect(() => {
    resetTimer();
    return () => clearInterval(timeoutRef.current);
  }, []);

  const current = testimonials[index];
  const motionConfig = { duration: 0.8, ease: 'easeInOut' };

  return (
    <TestimonialSection>
      <Container>
        <Header>
          <Title>
            What the <Highlight>Industry</Highlight> Is Saying
          </Title>
          <div className="right-content">
            <Subtitle>
              From development execution to story analysis — see how professionals are using our
              tools to streamline coverage and elevate storytelling.
            </Subtitle>
            <div className="right-content-btn">
              <NavButtons>
                <IconButton black onClick={onPrev}>
                  <ArrowLeft />
                </IconButton>
                <IconButton onClick={onNext}>
                  <ArrowRight />
                </IconButton>
              </NavButtons>{' '}
            </div>
          </div>
        </Header>

        <TestimonialGrid>
          <AnimatePresence mode="wait">
            <motion.div
              className="lft-col"
              key={`quote-${index}`}
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 10 }}
              transition={motionConfig}>
              <Quote>{current.quote}</Quote>
              <Person>
                <Name>{current.name}</Name>
                <Role>{current.role}</Role>
              </Person>
            </motion.div>
          </AnimatePresence>

          <AnimatePresence mode="wait">
            <motion.div
              key={`img-${index}`}
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 10 }}
              transition={motionConfig}>
              <ImageWrapper>
                <img
                  src={current.image}
                  alt={`${current.name || 'Industry user'} testimonial`}
                  loading="lazy"
                  decoding="async"
                />
              </ImageWrapper>
            </motion.div>
          </AnimatePresence>
        </TestimonialGrid>
      </Container>
    </TestimonialSection>
  );
}
